import { useCallback, useEffect, useState } from "react";
import { Turnstile } from "./Turnstile";
import { getDeviceHash } from "../lib/device";
import { requestAttestation } from "../lib/api";
import { persistStorageIfPossible } from "../lib/db";
import { useAppStore } from "../stores/useAppStore";

export function ConsentGate() {
  const { consented, setConsented, setDeviceHash, setAttest, setLastError } = useAppStore();
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);
  const [persisted, setPersisted] = useState<boolean | null>(null);

  useEffect(() => {
    getDeviceHash().then(setDeviceHash).catch(() => undefined);
  }, [setDeviceHash]);

  const accept = useCallback(async () => {
    setBusy(true);
    setLastError(undefined);
    try {
      const [hash, storagePersisted] = await Promise.all([getDeviceHash(), persistStorageIfPossible()]);
      setPersisted(storagePersisted);
      const response = await requestAttestation(hash, token || "dev-turnstile-bypass");
      setDeviceHash(hash);
      setAttest(response.attest);
      setConsented(true);
    } catch (error) {
      setLastError(error instanceof Error ? error.message : String(error));
    } finally {
      setBusy(false);
    }
  }, [setAttest, setConsented, setDeviceHash, setLastError, token]);

  if (consented) return null;

  return (
    <section className="consent-card" aria-labelledby="consent-title">
      <div>
        <p className="eyebrow">Human cognition commons</p>
        <h2 id="consent-title">Before the atlas can glow</h2>
        <p className="consent-line">
          I consent to contribute anonymous touch/dwell attention traces to a public aggregate commons; I keep my local archive and can erase it.
        </p>
      </div>
      <Turnstile onToken={setToken} />
      <button className="primary" onClick={accept} disabled={busy || (!token && Boolean(import.meta.env.VITE_TURNSTILE_SITE_KEY))}>
        {busy ? "Opening atlas…" : "Agree + enter"}
      </button>
      {persisted === false && <p className="small muted">Persistent storage was not granted; local history may be evicted by the browser under pressure.</p>}
    </section>
  );
}
